export default Object.freeze({
  DATABASE: 'DATABASE',
  REGISTRY: 'REGISTRY',
  OTHER: 'OTHER',
});
